import React from 'react'
import { CapsuleTabs } from 'antd-mobile'
import './index.scss'
function MonthPicker(props) {
  const { monthSelect, month } = props
  const list = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']

  return (
    <div className="month-pick">
      <CapsuleTabs activeKey={month + ''}
          onChange={(v) => {
          monthSelect(v)
        }}>
        {list.map((item) => {
          return <CapsuleTabs.Tab key={item}
              title={`${item}月`}></CapsuleTabs.Tab>
        })}
      </CapsuleTabs>
    </div>

  )
}
export default MonthPicker